import React from 'react';
import TrafficFee from './TrafficFeeV1';
import '../../Style/defaultstyle.css'
import '../../Style/defaultstyle.scss'

const ProtitleNew = (params) => {
  return (
    <table style={params.classNameWrapper}>
      <tr style={params.classNameItem}>
        <td style={params.PadProTitle}>
          <text style={StySpecification.ColorText} className='sub-title'>{params.Title} </text>
        </td>
      </tr>
      <tr style={params.Tableborder}>
        <td style={params.PadPro} >
          <text style={params.ConTitle}><span  >{params.Core} </span></text>
        </td>
      </tr>
      <tr style={params.Tableborder}>
        <td style={params.PadPro} >
        <text style={params.ConTitle}><span  >{params.G} </span></text>
        </td>
      </tr>
      <tr style={params.Tableborder}>
        <td style={params.PadPro} >
        <text style={params.ConTitle}><span  >{params.SD}</span></text>
        </td>
      </tr>
      <tr style={params.Tableborder}>
        <td style={params.PadPro} >
        <text style={params.ConTitle}><span  >{params.SG}</span></text>
        </td>
      </tr>
      <tr style={params.Tableborder}>
        <td style={params.PadPro} >
        <text style={params.ConTitle}><span  >{params.data5}</span></text>
        </td>
      </tr>
      <tr style={params.Tableborderlast}>
        <td style={params.PadPro} >
        <text style={params.ConTitle}><span  >{params.data6}</span></text>
        </td>
      </tr>
    </table>
  )
}

const Protitle = (params) => {
  return (
    <table style={params.classNameWrapper}>
      <tr>
        <td style={params.PadProTable} >
          <text style={StySpecification.ColorText} className='sub-title'>&nbsp;</text>
        </td>
      </tr>
      <tr>
        <td style={params.PadProtit} >
          <text style={params.ConTitle}><span  >{params.Core} </span></text>
        </td>
      </tr>
      <tr>
        <td style={params.PadProtit} >
        <text style={params.ConTitle}><span  >{params.G} </span></text>
        </td>
      </tr>
      <tr>
        <td style={params.PadProtit} >
        <text style={params.ConTitle}><span  >{params.SD}</span></text>
        </td>
      </tr>
      <tr>
        <td style={params.PadProtit} >
        <text style={params.ConTitle}><span  >{params.SG}</span></text>
        </td>
      </tr>
      <tr>
        <td style={params.PadProtit} >
        <text style={params.ConTitle}><span  >{params.data5}</span></text>
        </td>
      </tr>
      <tr>
        <td style={params.PadProtit} >
        <text style={params.ConTitle}><span  >{params.data6}</span></text>
        </td>
      </tr>
    </table>
  )
}

function ServerPricing() {
  return (
    <>
      <div style={StySpecification.StylesAll}>
        <div style={StySpecification.StylesContainer}>
          <div >
            <div >
              <h2 style={StySpecification.Title} className='header'> Kubernetes for ScyllaDB 요금안내 </h2>
              <p style={StySpecification.Text} className='sub-title'>
                <text >리플리카구성 및 Shard 분산처리, 대용량 고가용성 분산 클라우드 Scylla(Cassandra)</text>
              </p>
            </div>
          </div>
          <div style={StySpecification.TableScroll}>
            <div style={StySpecification.TableWrap}>
              <div style={StySpecification.ListProduct}>

                {Protitle({
                  classNameWrapper: StySpecification.InfPro,
                  classNameItem: StySpecification.ProductTitle,
                  PadProTable: StySpecification.PadProTable,
                  PadProtit: StySpecification.PadProtit,
                  ConTitle: StySpecification.ConTitle,
                  // Title: "hi",
                  Core: "CPU",
                  G: "Memory",
                  SD: "Storage",
                  SG: "Traffic 전송량(월)",
                  data5: "가상서버(POD) 최소수량",
                  data6: "서비스비용(월)"

                })}

                {ProtitleNew({
                  classNameWrapper: StySpecification.InfProduct,
                  classNameItem: StySpecification.ProductTitle,
                  PadProTitle: StySpecification.PadProTitle,
                  Tableborder: StySpecification.Tableborder,
                  Tableborderlast: StySpecification.Tableborderlast,
                  Title: "스탠다드 상품",
                  Core: "1 Core",
                  G: "4G",
                  SD: "SSD 100G",
                  SG: "900G",
                  data5: "가상서버(POD) 3대, LB 1대",
                  data6: "72,500"

                })}

                {ProtitleNew({
                  classNameWrapper: StySpecification.InfProduct,
                  classNameItem: StySpecification.ProductTitle,
                  PadProTitle: StySpecification.PadProTitle,
                  Tableborder: StySpecification.Tableborder,
                  Tableborderlast: StySpecification.Tableborderlast,
                  Title: "비지니스",
                  Core: "2 Core",
                  G: "8G",
                  SD: "SSD 100G",
                  SG: "900G",
                  data5: "가상서버(POD) 3대, LB 1대",
                  data6: "125,000"

                })}
                {ProtitleNew({
                  classNameWrapper: StySpecification.InfProduct,
                  classNameItem: StySpecification.ProductTitle,
                  PadProTitle: StySpecification.PadProTitle,
                  Tableborder: StySpecification.Tableborder,
                  Tableborderlast: StySpecification.Tableborderlast,
                  Title: "엔터프라이즈형",
                  Core: "4 Core",
                  G: "16G",
                  SD: "SSD 100G",
                  SG: "900G",
                  data5: "가상서버(POD) 3대, LB 1대",
                  data6: "230,000"
                })}
              </div>
            </div>
          </div>
          <div style={StySpecification.TextContent} >
          <span >
            - 오토스케일링으로 확장된 클러스터는 추가된 컨테이너의 수량만큼 과금됩니다.<br />
          <span style={StySpecification.geek}>
            - 다양한 방식으로 쿠베네티스 클러스터를 구축할 수 있습니다. (Cloud 구축운영컨설팅) <br />
            - 가상서버(POD) 4대이상의 자원으로 클러스터를 구성합니다.
          </span>
          </span>

          </div>
          <div style={StySpecification.BoxCenter}>
            <text style={StySpecification.TextCenter} className='sub-title'>가상서버(인스턴스) 기반 단독 Scylla (Cassandra) 데이터베이스</text>
          </div>
          <div style={StySpecification.TableScroll}>
            <div style={StySpecification.TableWrap}>
              <div style={StySpecification.ListProduct}>

                {Protitle({
                  classNameWrapper: StySpecification.InfPro,
                  classNameItem: StySpecification.ProductTitle,
                  PadProTable: StySpecification.PadProTable,
                  PadProtit: StySpecification.PadProtit,
                  ConTitle: StySpecification.ConTitle,
                  // Title: "hi",
                  Core: "CPU",
                  G: "Memory",
                  SD: "Storage",
                  SG: "Traffic 전송량(월)",
                  data5: "서비스비용(월)"

                })}

                {ProtitleNew({
                  classNameWrapper: StySpecification.InfProduct,
                  classNameItem: StySpecification.ProductTitle,
                  PadProTitle: StySpecification.PadProTitle,
                  Tableborder: StySpecification.Tableborder,
                  Tableborderlast: StySpecification.Tableborderlast,
                  Title: "스탠다드 상품",
                  Core: "2 Core",
                  G: "8G",
                  SD: "SSD 100G",
                  SG: "900G",
                  data5: "35,000"

                })}

                {ProtitleNew({
                  classNameWrapper: StySpecification.InfProduct,
                  classNameItem: StySpecification.ProductTitle,
                  PadProTitle: StySpecification.PadProTitle,
                  Tableborder: StySpecification.Tableborder,
                  Tableborderlast: StySpecification.Tableborderlast,
                  Title: "비지니스",
                  Core: "4 Core",
                  G: "16G",
                  SD: "SSD 200G",
                  SG: "900G",
                  data5: "70,000"

                })}
                {ProtitleNew({
                  classNameWrapper: StySpecification.InfProduct,
                  classNameItem: StySpecification.ProductTitle,
                  PadProTitle: StySpecification.PadProTitle,
                  Tableborder: StySpecification.Tableborder,
                  Tableborderlast: StySpecification.Tableborderlast,
                  Title: "엔터프라이즈형",
                  Core: "8 Core",
                  G: "32G",
                  SD: "SSD 400G",
                  SG: "900G",
                  data5: "150,000"
                })}
              </div>
            </div>
          </div>
          <div style={StySpecification.StylesCenter}></div>
          <TrafficFee />
        </div>
      </div>
    </>

  );
}


const StySpecification = {
  StylesAll: {
    display: "flex",
  },
  ConTitle: {
    color: "black",
  },
  geek: {
    background: "yellow",
    fontWeight: "bold",
  },
  StylesContainer: {
    width: "100%",
    boxShadow: "0 0.375rem 1.5rem 0 rgb(140 152 164 / 13%)",
    border: "1px solid #E7EAF3",
    borderRadius: "8px",
    padding: 20,
    marginTop: 30,
    marginBottom: 30,
  },
  StylesCenter: {
    display: "flex",
    width: "100%",
  },
  StylesTitle: {
    textAlign: "center",
  },
  TextCenter: {
    padding: 10,
    fontWeight: 600,
    margin: "auto",
  },
  BoxCenter: {
    background: "#F3F5F9",
    width: "100%",
    display: "flex",
    marginBottom: 40,
    borderRadius: "10px",
    padding: 8,

  },
  Title: {
    fontWeight: "bold",
    borderRadius: "20px",
    marginTop: "20px",
    marginBottom: "20px",
  },
  Text: {
    fontWeight: 600,
    marginBottom: "30px",
  },
  ColorText: {
    color: "white",
  },
  TextContent: {
    width: "75%",
    float: "right",
    textAlign: "left",
    paddingLeft: 15,
    marginTop: 15,
    marginBottom: 30
  },
  ProductTitle: {
    background: "#393939",
    fontWeight: "bold",
    borderTopLeftRadius: "8px",
    borderTopRightRadius: "8px",
    // paddingTop: 8,
    // paddingBottom: 8,

  },
  Tableborder: {
    borderLeft: "1px solid #D7E5ED",
    borderRight: "1px solid #D7E5ED",
  },
  Tableborderlast: {
    borderLeft: "1px solid #D7E5ED",
    borderRight: "1px solid #D7E5ED",
    borderBottom: "1px solid #D7E5ED",
  },
  ProTitleLeft: {
    fontWeight: 500,
    paddingTop: 8,
    paddingBottom: 8,
  },
  InfProduct: {
    borderRadius: "8px",
    width: "25%",
    marginLeft: 20,
    // border: "1px solid #D7E5ED",
    whiteSpace: "nowrap",
    minWidth: "170px",
  },
  InfPro: {
    borderRadius: "8px",
    width: "25%",
    marginRight: 10,
    textAlign: "right",
    fontWeight: 700,
    whiteSpace: "nowrap",
    minWidth: "130px",
  },

  ListProduct: {
    display: "flex",

  },
  PadPro: {
    padding: "12px 0",
  },
  PadProtit: {
    padding: "6px 0",
  },
  PadProTable: {
    padding: "10px 0",
  },
  PadProTitle: {
    borderTopLeftRadius: "8px",
    borderTopRightRadius: "8px",
    background: "unset",
  },
  TableScroll: {
    position: "relative",
    width: "100%",
    margin: "auto",
    overflow: "hidden",
    whiteSpace: "nowrap",
  },
  TableWrap: {
    width: "100%",
    overflow: "auto",
  }

}





export default ServerPricing;
